/**
 * Created by mqamhieh on 10/27/16.
 */
(function (app, hChart) {

    app.directive('donutChart',
        [   "DispatcherServices",
            function (DispatcherServices) {
                return {
                    restrict: "E",
                    scope: {
                        color: '@',
                        size: '@',
                        percentage: '=',
                        tooltipTitle: '@'
                    },
                    templateUrl: '../modules/chart/views/donut_chart_directive.html',
                    link: function ($scope, $element, $attrs) {

                        var chartColor = $scope.color || "rgb(64, 131, 221)";
                        var size = $scope.size || 50;

                        var chartData = {
                            "x": [$scope.tooltipTitle],
                            "y": [
                                {
                                    "key": $scope.tooltipTitle,
                                    "color": chartColor,
                                    "value": [Math.round($scope.percentage * 100)],
                                    "type": hChart.CHART_TYPES.GAUGE
                                }
                            ],
                            "hideLegend": true,
                            "xAxisType": hChart.X_AXIS_TYPES.CATEGORY,
                            size: {
                                height: size,
                                width: size
                            },
                            dataType: hChart.CHART_TYPES.GAUGE,
                            gaugeWidth: 10,
                            gaugeLabelFormat: function () {
                                return null;
                            },
                            "hideLabel": true,
                            tooltipNameFormat: function (name, ratio, id, index) {
                                return $scope.tooltipTitle;
                            },
                            tooltipValueFormat: function (value, ratio, id) {
                                return value + "%";
                            },
                            tooltipPosition: function (data, width, height, thisElement) {
                                var tooltip = $element.find(".c3-tooltip-container");
                                return {
                                    top: $element.offset().top - $element.offset().top - ($element.height()),
                                    left: size
                                };
                            }
                        };

                        var reportingChart = new hChart($element.find("#chart"), DispatcherServices.getNunjucks());
                        reportingChart.render(chartData);

                        $scope.$on("$destroy", function () {

                        });
                    }
                };
            }
        ]);
})(angular.module("harriApp"), HChart);
